jQuery(document).on('ShoptetDOMContentLoaded ready', function() {
  // pouze v košíku a pokud jsme ještě nezaložili element .change
  if (!jQuery('body').hasClass('in-kosik') || jQuery('.change').length > 0) {
    return
  }

  // HTML pro dárcovská tlačítka
  const t = `
    <div class="change">
      <div class="coins">
        <h4>Dýška pro skladníky:</h4>
        <p>Dýško férově rozdělíme mezi tým skladníků</p>
        <img class="five" src="https://www.vyspimese.cz/user/documents/upload/temp/cart/5-kc.svg" alt="5 Kč" />
        <img class="ten" src="https://www.vyspimese.cz/user/documents/upload/temp/cart/10-kc.svg" alt="10 Kč" />
        <img class="twenty" src="https://www.vyspimese.cz/user/documents/upload/temp/cart/20-kc.svg" alt="20 Kč" />
        <img class="fifty" src="https://www.vyspimese.cz/user/documents/upload/temp/cart/50-kc.svg" alt="50 Kč" />
      </div>
    </div>
  `

  if (jQuery('.cart-inner:contains("Dýška")').length === 0) {

    //jQuery(t).insertAfter('#my-product-toggles')
    jQuery(t).appendTo('.cart-summary .extras-wrapper .extras-col:nth-of-type(1)')
  }

  let existingTipItem = null
  jQuery.each(dataLayer[0].shoptet.cart, function(_, item) {
    if (item.priceId === 1152) {
      existingTipItem = item.itemId
    }
  })

  const addTip = function(selector, priceId) {
    jQuery(document).on('click', selector, function() {
      if (!jQuery(this).data('clicked')) {
        shoptet.cartShared.addToCart({ priceId: priceId })
        jQuery(this).data('clicked', true)
      }
    })
  }

  addTip('img.five', 678957)
  addTip('img.ten', 678954)
  addTip('img.twenty', 678960)
  addTip('img.fifty', 678963)
})
